import {Component} from 'react';
import { doubleToStringMonthly, standardNumberFormat} from '../../../objects/CommonUse/double_functions';
import { reformatDateToDisplay } from '../../../objects/CommonUse/reformatDateToDisplay_function';


class InvestmentTransactionHistoryCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, 
             selected: false,
           
        };
    }

    prepareDataForDisplay(){
        this.gainLossClass = "text-right";
        if (+this.props.historyInfo.totalGainLoss < 0){
            this.gainLossClass += " text-danger";
        }
        this.dateClosed = "";
        if (this.props.historyInfo.dateClosed !== ""){
            this.dateClosed = reformatDateToDisplay(this.props.historyInfo.dateClosed);
        }
        if (this.props.historyInfo.quantity !== ""){
            this.quantity = standardNumberFormat(this.props.historyInfo.quantity);
        }
        if (this.props.historyInfo.buyAmount !== ""){
            this.buyAmount = doubleToStringMonthly(this.props.historyInfo.buyAmount);
        }
        if (this.props.historyInfo.sellAmount !== ""){
            this.sellAmount = doubleToStringMonthly(this.props.historyInfo.sellAmount)
        }
    }

    render() {
       this.prepareDataForDisplay();
    return <>
        <tr>
            <th className="text-left">{this.props.historyInfo.investmentName}</th>
            <td className="text-left">{this.props.historyInfo.tranType}</td>
            <td className="text-center">{this.dateClosed}</td>
            <td className="text-right">{this.quantity}</td>
            <td className="text-right">{this.buyAmount}</td>
            <td className="text-right">{this.sellAmount}</td>
            <td className={this.gainLossClass}>{doubleToStringMonthly(this.props.historyInfo.totalGainLoss)}</td>
        </tr>
          
    </>
    }

}

export default InvestmentTransactionHistoryCard;